export class TableCellButton {

    id: string;
    icon: string;
    description: string;
    visible = true;

    constructor (id: string, icon: string, description?: string, visible = true) {
        this.id = id;
        this.icon = icon;
        this.description = description;
        this.visible = visible;
    }

}
